export default __webpack_public_path__ + "static/media/231.a00ff16e.gif";